declare global {
  // tslint:disable-next-line:interface-name
  interface Window {
    lastActionDispatch: number;
  }
}

export function timestampMiddleware() {
  return next => action => {
    if (!(process.versions && process.versions.node)) {
      window.lastActionDispatch = Date.now();
    }
    return next(action);
  };
}
